module.exports = __webpack_public_path__ + "img/card-image-101.ae418bc.webp";